module.exports = __webpack_public_path__ + "media/images/donation/logo-rsaitama-ebd252337bb411308812f0187614d1ca.jpg";